import { memo, useMemo } from 'react';
import useNavigateWithSearch from '../../../../../hooks/useNavigateWithSearch';

import { formatExpiryDate, formatCardNumber } from '../utils';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../global/Button';
import { ROUTE_MEMBERSHIP_PAYMENT_METHOD } from '../../../config/routes';

import './PaymentMethod.scss';

const PaymentMethod = ({ paymentDetails }) => {
  const cardInfoFields = useMemo(() => [
    {
      id: 'details',
      label: 'Details',
      value: paymentDetails?.displayUserName || 'N/A',
    },
    {
      id: 'brand',
      label: 'Brand',
      value: paymentDetails?.brand || 'N/A',
    },
    {
      id: 'type',
      label: 'Type',
      value: paymentDetails?.funding || 'N/A',
    },
    {
      id: 'cardNumber',
      label: 'Card Number',
      value: formatCardNumber(paymentDetails?.last4),
    },
    {
      id: 'expiryDate',
      label: 'Exp. Date',
      value: formatExpiryDate(paymentDetails?.expiryMonth, paymentDetails?.expiryYear),
    },
  ], [paymentDetails]);
  const navigateWithSearch = useNavigateWithSearch();

  return (
    <div className="PaymentMethod">
      <div className="PaymentMethod__container">
        <div className="PaymentMethod__container--content">
          <div className="PaymentMethod__container--content--description">
            Your charges will be deducted from the default card shown below.
            You can change this by adding a new card.
          </div>
          <div className="PaymentMethod__container--content--card-info">
            {cardInfoFields.map((field) => (
              <div
                key={field.id}
                className="PaymentMethod__container--content--card-info--item"
              >
                <div className="PaymentMethod__container--content--card-info--item--label">
                  {field.label}
                </div>
                <div className="PaymentMethod__container--content--card-info--item--value">
                  {field.value}
                </div>
              </div>
            ))}
          </div>
          <Button
            type={BUTTON_TYPE.TERTIARY}
            size={BUTTON_SIZE.LARGE}
            onClick={() => navigateWithSearch(ROUTE_MEMBERSHIP_PAYMENT_METHOD)}
            className="PaymentMethod__container--cta"
          >
            Edit your card
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(PaymentMethod);
